"use strict";
/*---------------------------------------------------------------------------------------------
*  Licensed to the .NET Foundation under one or more agreements.
*  The .NET Foundation licenses this file to you under the MIT license.
*--------------------------------------------------------------------------------------------*/
Object.defineProperty(exports, "__esModule", { value: true });
exports.DEBIAN_DISTRO_INFO_KEY = exports.RED_HAT_DISTRO_INFO_KEY = exports.UBUNTU_DISTRO_INFO_KEY = exports.UNABLE_TO_ACQUIRE_GLOBAL_LOCK_ERR = void 0;
exports.GLOBAL_INSTALL_STATE_MODIFIER_LOCK = GLOBAL_INSTALL_STATE_MODIFIER_LOCK;
exports.RUN_UNDER_SUDO_LOCK = RUN_UNDER_SUDO_LOCK;
/*
* @remarks Hold this when using an installer that impacts the entire system state (not just user local state.)
* This lock is unaware of external programs running MSIs that may conflict and also edit the global machine state.
* But, it at least prevents the extension from tripping over itself.
*/
function GLOBAL_INSTALL_STATE_MODIFIER_LOCK(directoryProvider, install) {
    return 'vscdGlLk';
}
function RUN_UNDER_SUDO_LOCK(sudoDirectory) {
    return 'vscdSudoLk';
}
exports.UNABLE_TO_ACQUIRE_GLOBAL_LOCK_ERR = '898998';
exports.UBUNTU_DISTRO_INFO_KEY = 'Ubuntu';
exports.RED_HAT_DISTRO_INFO_KEY = 'Red Hat Enterprise Linux';
exports.DEBIAN_DISTRO_INFO_KEY = 'Debian GNU/Linux';
//# sourceMappingURL=StringConstants.js.map